import type { UserPlan } from '@/contexts/UserContext';

export interface PlanFeature {
  text: string;
  included: boolean;
}

export interface PlanDefinition {
  key: UserPlan;
  name: string;
  description: string;
  lookupKey: string | null;
  highlight: boolean;
  features: PlanFeature[];
  color: string;
}

export const planDefinitions: PlanDefinition[] = [
  {
    key: 'light',
    name: 'Light',
    description: 'Para quem quer começar a organizar seus projetos e materiais',
    lookupKey: null,
    highlight: false,
    color: 'bg-sage text-accent-foreground',
    features: [
      { text: 'Registro de projetos', included: true },
      { text: 'Controle básico de sessões', included: true },
      { text: 'Resumo de tempo por projeto', included: true },
      { text: 'Gestão de Estoque', included: true },
      { text: 'Calculadora de custos', included: true },
      { text: 'IArisco - 1 crédito inicial', included: true },
      { text: 'Cronômetro integrado', included: false },
      { text: 'CRM de encomendas', included: false },
      { text: 'Precificação assistida', included: false },
      { text: 'Vitrine Artesã', included: false },
    ],
  },
  {
    key: 'pro',
    name: 'Pro',
    description: 'Para quem quer acompanhar cada projeto com mais profundidade e precisão',
    lookupKey: 'pro_monthly',
    highlight: false,
    color: 'bg-primary text-primary-foreground',
    features: [
      { text: 'Tudo do Light', included: true },
      { text: 'Sessões ilimitadas e detalhadas', included: true },
      { text: 'Cronômetro integrado', included: true },
      { text: 'Fotos do processo', included: true },
      { text: 'Gráficos e análises', included: true },
      { text: 'Histórico completo de sessões', included: true },
      { text: 'Previsão de conclusão', included: true },
      { text: 'IArisco - 2 créditos por mês', included: true },
      { text: 'CRM de encomendas', included: false },
      { text: 'Precificação assistida', included: false },
      { text: 'Vitrine Artesã', included: false },
    ],
  },
  {
    key: 'avancado',
    name: 'Avançado',
    description: 'A experiência completa do Artesã: venda, organize e profissionalize com tudo liberado',
    lookupKey: 'advanced_monthly',
    highlight: true,
    color: 'bg-lavender text-foreground',
    features: [
      { text: 'Tudo do Pro', included: true },
      { text: 'Encomendas', included: true },
      { text: 'Orçamentos', included: true },
      { text: 'Cadastro de clientes', included: true },
      { text: 'Precificação assistida', included: true },
      { text: 'Relatórios avançados', included: true },
      { text: 'Inteligência de mercado', included: true },
      { text: 'IArisco - 3 créditos por mês', included: true },
      { text: 'Logo da empresa', included: true },
      { text: 'Vitrine Artesã (página pública de produtos)', included: true },
    ],
  },
];

export function getPlanByKey(key: UserPlan): PlanDefinition {
  return planDefinitions.find(p => p.key === key)!;
}
